import React, { useState } from 'react';

const SCREENS = [
  {
    title: 'A world inside you',
    body: "The Inner World is a gentle place made of four realms — and an open horizon beyond them. Each one holds a different kind of reflection — grounding, curiosity, listening, and belonging.",
  },
  {
    title: 'Companions, not enemies',
    body: "The parts of you that you meet here are companions, never enemies. There are no battles, no fail states, and nothing you can get wrong. Any reflection you offer is enough.",
  },
  {
    title: 'You can pause anytime',
    body: "'Rest at the Shore' is always one tap away — leaving is never a failure. This is for reflection, not treatment. If things feel like too much, reach out to a licensed therapist.",
  },
];

export const InnerWorldOnboarding = ({ onComplete }) => {
  const [step, setStep] = useState(0);
  const isLast = step === SCREENS.length - 1;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{ background: 'rgba(251,249,246,0.96)', backdropFilter: 'blur(12px)' }}
      data-testid="inner-world-onboarding"
    >
      <div className="max-w-sm text-center">
        <div className="flex justify-center gap-2 mb-8">
          {SCREENS.map((s, i) => (
            <div key={s.title} className="w-2 h-2 rounded-full transition-all" style={{ background: i === step ? '#C9A84C' : '#DFD9D0' }} />
          ))}
        </div>
        <h2 className="text-lg md:text-lg mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}>
          {SCREENS[step].title}
        </h2>
        <p className="text-sm leading-relaxed mb-10" style={{ fontFamily: 'Jost, sans-serif', color: 'rgba(232,180,184,0.75)' }}>
          {SCREENS[step].body}
        </p>
        <button
          onClick={() => (isLast ? onComplete() : setStep(step + 1))}
          className="px-8 py-3 rounded-full text-sm tracking-[0.1em] transition-all active:scale-95"
          style={{ background: 'rgba(201,168,76,0.15)', color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}
          data-testid={isLast ? 'onboarding-enter-button' : 'onboarding-next-button'}
        >
          {isLast ? 'ENTER THE INNER WORLD' : 'CONTINUE'}
        </button>
      </div>
    </div>
  );
};
